import { Component, OnDestroy, Output, EventEmitter } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';

import { Subscription, switchMap } from 'rxjs';
import { filter } from 'rxjs/operators';

import { TabComponent } from '@Common/Layout/components/Tab/tab.component';
import { ButtonTypesEnum } from '@Common/Forms/enums/button-types.enum';
import { messageSeverityEnum } from '@Common/Misc/enums/message-severity.enum';
import { PersonalizationSummary } from '@api/distributions/model/distribution-personalization.api.model';
import { DistributionService } from '@Common/TargetingShared/services/distribution.service';
import { DistributionStepsEnum } from '../DistributionStepsNavigation/distribution-steps-navigation.component';
import { PersonalizationService } from '@Discover/Targeting/services/personalization.service';
import { PersonalizationTagEnum } from '@Discover/Targeting/enums/personalization-tag.enum';

@Component({
    selector: 'agpr-personalization-tab',
    templateUrl: './personalization-tab.component.html',
    styleUrls: ['./personalization-tab.component.scss'],
    providers: [
        {
            provide: TabComponent,
            useExisting: PersonalizationTabComponent
        }
    ],
    animations: [
        trigger('panelContent', [
            state('hidden', style({
                height: '0',
                opacity: 0
            })),
            state('visible', style({
                height: '*',
                opacity: 1
            })),
            transition('visible <=> hidden', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ],
    standalone: false
})
export class PersonalizationTabComponent extends TabComponent implements OnDestroy {

    @Output() changeStep: EventEmitter<DistributionStepsEnum> = new EventEmitter();

    collapsed: boolean = true;
    animating: boolean = false;
    distributionId: number;
    personalizationSummary: PersonalizationSummary[] = [];

    readonly buttonTypes = ButtonTypesEnum;
    readonly messageSeverityEnum = messageSeverityEnum;
    readonly personalizationOrder = [
        // NEP-18499 PersonalizationTagEnum.NAME,
        PersonalizationTagEnum.PREFIX,
        PersonalizationTagEnum.FNAME,
        PersonalizationTagEnum.LNAME,
        PersonalizationTagEnum.OUTLET_NAME,
        PersonalizationTagEnum.X_HANDLE,
        PersonalizationTagEnum.INTRO,
        PersonalizationTagEnum.OUTRO
    ];

    private subscriptions: Subscription[] = [];

    constructor(
        private distributionService: DistributionService,
        private personalizationService: PersonalizationService,
    ) {
        super();

        this.subscriptions.push(
            this.distributionService.getFocusedResource().pipe(
                filter(x => !!x),
                switchMap(distribution => {
                    this.distributionId = distribution.id;

                    return this.personalizationService.getSummary();
                })
            ).subscribe((personalizationSummary) => {
                this.personalizationSummary = personalizationSummary.sort((a, b) => {
                    return this.personalizationOrder.indexOf(a.tagType) - this.personalizationOrder.indexOf(b.tagType);
                });
            })
        );
    }


    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
